// src/components/TermsAndConditions.js
import React from 'react';
import PolicyPage from './PolicyPage';

function TermsAndConditions() {
  return (
    <PolicyPage title="Terms & Conditions" lastUpdated="[Date]">
      <p>By using IronBhai's services (laundry, ironing, dry cleaning, saree rolling, and related offerings), you agree to the following Terms & Conditions:</p>
      <h2>1. Service Scope</h2>
      <ul>
        <li>Services are provided as per the options selected in the IronBhai app or via our authorized channels.</li>
        <li>We reserve the right to refuse or cancel any order at our discretion.</li>
      </ul>
      <h2>2. Orders & Pickup</h2>
      <ul>
        <li>Orders must be placed through our official app, website, or customer service channels.</li>
        <li>Pickup and delivery timings are based on slot availability and may be rescheduled in case of operational constraints.</li>
      </ul>
      <h2>3. Pricing & Payment</h2>
      <ul>
        <li>Prices are listed in the app and may vary by service, location, or promotions.</li>
        <li>Payments must be completed via the app's supported methods before delivery, unless Cash on Delivery (COD) is chosen.</li>
      </ul>
      <h2>4. Garment Handling & Liability</h2>
      <ul>
        <li>We take utmost care of all items but are not responsible for pre-existing damage, color fading, or wear and tear.</li>
        <li>Shrinkage or damage due to manufacturer's defect or poor fabric quality is not our liability.</li>
        <li>In case of loss or damage solely due to our negligence, compensation will not exceed 5 times the service cost of the affected item.</li>
      </ul>
      <h2>5. Uncollected Items</h2>
      <ul>
        <li>Items not collected/delivered within 30 days from the scheduled delivery date will be considered abandoned and may be donated/disposed without further notice.</li>
      </ul>
      <h2>6. Cancellations & Refunds</h2>
      <ul>
        <li>Orders can be cancelled before pickup.</li>
        <li>Refunds (if applicable) will be processed as per our refund policy within 7-10 business days.</li>
      </ul>
      <h2>7. Customer Responsibilities</h2>
      <ul>
        <li>Check all pockets for valuables before handing over garments.</li>
        <li>Provide accurate contact details and delivery address.</li>
        <li>Ensure someone is available at the delivery location during the scheduled time.</li>
      </ul>
      <h2>8. Service Limitations</h2>
      <ul>
        <li>We do not guarantee removal of all stains.</li>
        <li>Certain delicate fabrics may be processed only after customer consent.</li>
      </ul>
      <h2>9. Promotions & Discounts</h2>
      <ul>
        <li>Offers and coupons are subject to change or withdrawal without prior notice.</li>
        <li>Only one promotional offer can be used per order unless stated otherwise.</li>
      </ul>
      <h2>10. Privacy & Data Use</h2>
      <ul>
        <li>Customer data will be used only for service delivery, communication, and marketing (if opted in), as per our Privacy Policy.</li>
      </ul>
      <h2>11. Dispute Resolution</h2>
      <ul>
        <li>Any disputes shall be resolved amicably. If unresolved, they will be subject to the jurisdiction of Hyderabad, Telangana courts.</li>
      </ul>
    </PolicyPage>
  );
}

export default TermsAndConditions;
